import { render, staticRenderFns } from "./EmailTable.vue?vue&type=template&id=42f35e2f&scoped=true&"
import script from "./EmailTable.vue?vue&type=script&lang=js&"
export * from "./EmailTable.vue?vue&type=script&lang=js&"
import style0 from "./EmailTable.vue?vue&type=style&index=0&id=42f35e2f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f35e2f",
  null
  
)

export default component.exports